<ng-container *ngIf="showAccordion">
  <ppl-accordion [title]="'Provider Services'" [isOpen]="true">
    <ng-container *ngTemplateOutlet="content">
    </ng-container>
  </ppl-accordion>
</ng-container>

<ng-container *ngIf="!showAccordion">
  <ng-container *ngTemplateOutlet="content">
  </ng-container>
</ng-container>

<ng-template #content>
  @if(mode==="read"){
  <form nz-form [formGroup]="consumerRateForm"
    class="row ppl-p0 form-container">
    <nz-form-item *ngIf="isProviderView" nz-col nzSpan="12"
      class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="participant_lkp"
          class="ppl-form-label">Participant
          <span>*</span>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
          <div nz-tooltip
            [nzTooltipTitle]="'Select Participant'"
            nzTooltipPlacement="topRight">
            <div [ngClass]="{'error': validationErrors['participant_lkp'] }">
              <ppl-dropdown-select
                id="participantId"
                formControlName="participantId"
                class="ppl-select"
                [options]="providerAssociations"
                [optionLabel]="'displayName'"
                [optionValue]="'participantId'"
                [placeholder]="'Select Participant'"
                (selectionChange)="onParticipantChange($event)">
              </ppl-dropdown-select>
            </div>
          </div>
          @if (validationErrors['participant_lkp']) {
          <span
            class="pl-1 error-message">{{validationErrors['participant_lkp']}}</span>
          }
          <div
            *ngIf="consumerRateForm.get('participantId')?.errors?.['required'] && consumerRateForm.get('participantId')?.touched"
            class="pl-1 error-message">
            Participant is required
          </div>
        </nz-form-control>
      </nz-row>
    </nz-form-item>
  </form>

  @if(isSectionEditable) {
  <div *ngIf="participantId && hasParticipantAddress && canEditRates"
    class="btn-group d-flex flex-row btn-group justify-content-end"
    style="display: flex; gap: 8px;">
    @if (showAuthorizeColumn && canAuthorizeRates) {
    <ppl-button [label]="'Authorize'" icon="fa fa-unlock"
      [customClass]="'alt-button'" [iconPosition]="'left'"
      [disabled]="selectedProhibitedRateIds.size === 0 || isAuthorizing"
      (click)="authorizeSelectedRates()"></ppl-button>
    }
    <ppl-button [label]="'Add Rate'" icon="fa fa-plus"
      [customClass]="'alt-button'" [iconPosition]="'left'"
      (click)="onClickAdd()"></ppl-button>
  </div>
  }

  <div class="ant-row">
    @if(participantId){
    @if(!isDataLoaded || !isAddressCheckDone) {
    <div class="ant-col-12 ppl-text-center ppl-mt24">
      <p-message severity="info">Loading...</p-message>
    </div>
    }
    @else if(!hasParticipantAddress) {
    <div class="ant-col-12 ppl-text-center ppl-mt24">
      <p-message severity="error">Participant does not have an
        address</p-message>
    </div>
    }
    @else if(gridData && gridData.length > 0) {
    <div class="ant-col-24">
      <p-table [value]="gridData" [responsiveLayout]="'scroll'">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of cols" class="service-details-header">
              {{ col.header }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex"
          let-col="cols">
          <tr>
            <td *ngFor="let col of cols">
              @switch(col.field) {
              @case('providerPPLId') {
              <div style="white-space: nowrap;">{{rowData?.providerPPLId}}</div>
              }
              @case('providerName') {
              <div style="white-space: nowrap;">{{rowData?.providerName}}</div>
              }
              @case('code') {
              <ng-container *ngFor="let rate of rowData?.serviceList">
                <div class="service-code-line">
                  <!-- Authorize checkbox sits with the service code it applies to. The slot is
                       rendered for every stacked line (empty when the rate is not locked) so the
                       service descriptions all start at the same x-position; the checkbox itself
                       only appears for locked rates, and only for users who can clear the flag. -->
                  <span *ngIf="showAuthorizeColumn" class="approval-checkbox-slot">
                    <label *ngIf="isRateProhibited(rate)" nz-checkbox
                      [ngModel]="isRateSelected(rate)"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="onProhibitionSelectionChange(rate, $event)"
                      [attr.aria-label]="'Authorize ' + (rate?.serviceDescription || rate?.code)">
                    </label>
                  </span>
                  {{rate?.serviceDescription}}
                  <!-- Shown to every user, not just those who can authorize: this is the only cue a
                       participant or read-only user gets that a rate cannot be edited yet. -->
                  <i *ngIf="isRateProhibited(rate)"
                    class="fa fa-exclamation-triangle approval-required" nz-tooltip
                    [nzTooltipTitle]="'Regional Center authorization is required for the spouse to provide this service. The service code should remain blocked until verified.'"
                    aria-label="Authorization required"></i>
                </div>
              </ng-container>
              }
              @case('rate') {
              <ng-container *ngFor="let rate of rowData?.serviceList">
                <div style="white-space: nowrap;" *ngIf="rowData?.providerType === 'IR'">{{rate?.rate | currency:'USD':'symbol':'1.2-2'}} </div>
                <div style="white-space: nowrap;" *ngIf="rowData?.providerType !== 'IR'"> - </div>
              </ng-container>
              }
              @case('premiumRate') {
              <ng-container *ngFor="let rate of rowData?.serviceList">
                <div style="white-space: nowrap;" *ngIf="rowData?.providerType === 'IR'">{{rate?.premiumRate | currency:'USD':'symbol':'1.2-2'}} </div>
                <div style="white-space: nowrap;" *ngIf="rowData?.providerType !== 'IR'"> - </div>
              </ng-container>
              }
              @case('fromDate') {
              <ng-container *ngFor="let rate of rowData?.serviceList">
                <div style="white-space: nowrap;">{{rate?.fromDate}}</div>
              </ng-container>
              }
              @case('toDate') {
              <ng-container *ngFor="let rate of rowData?.serviceList">
                <div style="white-space: nowrap;">{{rate?.toDate}}</div>
              </ng-container>
              }
              @case('actions') {
              @if (hasParticipantAddress && canEditRates && isSectionEditable){
              <div class="mobile-actions d-flex">
                <!-- keep action icons compact for mobile -->
                <ppl-button label *ngIf="showEditButton"
                  (click)="onEdit(rowData, 'edit')" icon="fa fa-pencil"
                  [customClass]="'ghost-button'"></ppl-button>
              </div>
              }
              }
              }
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    }
    @else if (!providers || providers.length === 0) {
    <div class="ant-col-12 ppl-text-center ppl-mt24">
      <p-message severity="info">No Active Providers</p-message>
    </div>
    }
    @else {
    <div class="ant-col-12 ppl-text-center ppl-mt24">
      <p-message severity="info">No Rates are available </p-message>
    </div>
    }
    }

    @if (!participantId && isProviderView) {
    <div class="card">
      <p-message severity="info">Please select a Participant to view
        Rates</p-message>
    </div>
    }
  </div>
  }
  @if(mode==="add" || mode === "update"){
  <div class="wiz-body">
    <div class="ppl-mt24">
      <form nz-form [formGroup]="consumerRateForm"
        class="row ppl-p0 form-container">
        @if(isAttrAvailable('provider_lkp')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="provider_lkp"
              class="ppl-form-label">Provider
              <span>*</span>
            </nz-form-label>
            <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('provider_lkp')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <div [ngClass]="{'error': validationErrors['provider_lkp'] }">
                  <ppl-dropdown-select formControlName="providerId"
                    id="providerId"
                    class="ppl-select"
                    [options]="providers"
                    [optionLabel]="'lkpValueName'"
                    [optionValue]="'lkpValueCode'"
                    [placeholder]="'Select Provider'">
                  </ppl-dropdown-select>
                </div>
              </div>
              @if (validationErrors['provider_lkp']) {
              <span
                class="pl-1 error-message">{{validationErrors['provider_lkp']}}</span>
              }
              <div
                *ngIf="consumerRateForm.get('providerId')?.errors?.['required'] && consumerRateForm.get('providerId')?.touched"
                class="pl-1 error-message">
                Provider is required
              </div>
            </nz-form-control>
          </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('code')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="code"
              class="ppl-form-label">{{getAttributes('code').label}}
              <span>*</span>
            </nz-form-label>
            <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('code')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <div [ngClass]="{'error': validationErrors['code'] }">
                  <ppl-multiselect formControlName="code"
                    id="servicecodeDetailId" class="ppl-select"
                    [options]="serviceCodes"
                    [optionLabel]="'label'"
                    [optionValue]="'servicecode_detail_id'"
                    [placeholder]="'Select Service Code'"
                    (ngModelChange)="onServiceChange(consumerRateForm.get('code')?.value)">
                  </ppl-multiselect>
                </div>
              </div>
              @if (validationErrors['code']) {
              <span
                class="pl-1 error-message">{{validationErrors['code']}}</span>
              }
              <div
                *ngIf="consumerRateForm.get('code')?.errors?.['required'] && consumerRateForm.get('code')?.touched"
                class="pl-1 error-message">
                Service Code is required
              </div>
            </nz-form-control>
          </nz-row>
        </nz-form-item>
        }
        <div formArrayName="serviceList" class="ppl-mt16"
          *ngIf="serviceDetails.length> 0">
          <p-table [value]="serviceDetails.controls"
            [columns]="availableColumns">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of availableColumns"
                  [style.width]="
              col.field === 'serviceCode' ? '25%' :
              col.field === 'fromDate' ? '20%' :
              col.field === 'toDate' ? '20%' :
              col.field === 'rate' ? '15%' :
              col.field === 'actions' ? '20%' : 'auto'
            "
                  class="service-details-header">
                  {{ col.header }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-details let-i="rowIndex"
              let-columns="columns">
              <tr [formGroup]="details" style="vertical-align: top;">
                <td *ngFor="let col of availableColumns"
                  [style.width]="
              col.field === 'selected' ? '5%' :
              col.field === 'serviceCode' ? '25%' :
              col.field === 'fromDate' ? '20%' :
              col.field === 'toDate' ? '20%' :
              col.field === 'rate' ? '15%' :
              col.field === 'actions' ? '20%' : 'auto'
            "
                  style="padding: 5px 11px;">
                  @switch(col.field) {
                  @case ('selected') {
                  <label nz-checkbox formControlName="selected"></label>
                  }
                  @case('serviceCode') {
                  <nz-form-label>
                    <strong>
                      {{getServiceCodeLabel(details.get('serviceCodeId')?.value, details.get('serviceCode')?.value)}}
                    </strong>
                    <!-- prepareEdit disables the whole row for a locked rate; without this the user
                         just sees dead inputs with no reason given. -->
                    <i *ngIf="details.get('prohibitionFlag')?.value"
                      class="fa fa-exclamation-triangle approval-required" nz-tooltip
                      [nzTooltipTitle]="'Regional Center authorization is required for the spouse to provide this service. The service code should remain blocked until verified.'"
                      aria-label="Authorization required"></i>
                  </nz-form-label>
                  }
                  @case('fromDate') {
                  <nz-form-item>
                    <nz-form-control>
                      <ppl-date-picker formControlName="fromDate"
                        [id]="'fromDate_'+i" [showIcon]="true"
                        dateFormat="mm/dd/yy"
                        [yearRange]="'1900:2050'" [iconDisplay]="'input'"
                        inputId="fromDateInput"
                        [panelStyleClass]="'custom-calendar-panel'"
                        [readonlyInput]="false"
                        [placeholder]="'Start Date'">
                      </ppl-date-picker>
                    </nz-form-control>
                  </nz-form-item>
                  <div class="pl-1 error-message"
                    *ngIf="(details.get('fromDate')?.errors || details.errors) && (details.get('fromDate')?.touched || details.get('fromDate')?.dirty)">
                    <span
                      *ngIf="details.get('fromDate')?.errors?.['required']">Start Date is required</span>
                  </div>
                  }
                  @case('toDate') {
                  <nz-form-item>
                    <nz-form-control>
                      <div class="d-flex">
                        <ppl-date-picker
                          formControlName="toDate"
                          [id]="'toDate_'+i" [showIcon]="true"
                          dateFormat="mm/dd/yy"
                          [yearRange]="'1900:2050'" [iconDisplay]="'input'"
                          inputId="toDateInput"
                          [panelStyleClass]="'custom-calendar-panel'"
                          [readonlyInput]="false"
                          [placeholder]="'End Date'">
                        </ppl-date-picker>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                  <div class="pl-1 error-message"
                    *ngIf="(details.get('toDate')?.errors || details.errors) && (details.get('toDate')?.touched || details.get('toDate')?.dirty || details.errors?.['dateRangeInvalid'])">
                    <span
                      *ngIf="details.get('toDate')?.errors?.['required']">End Date is required</span>
                    <span
                      *ngIf="details.errors?.['dateRangeInvalid']">End Date must be after Start Date</span>
                  </div>
                  }
                  @case('rate') {
                  <nz-form-item>
                    <nz-form-control>
                      <div class="d-flex">
                        <input nz-input formControlName="rate"
                          [id]="'rate_' + i" placeholder="Rate"
                          style="width: 120px;"
                          [ngClass]="{'error': validationErrors['rate'] || (details.get('rate')?.invalid && (details.get('rate')?.touched || details.get('rate')?.dirty)) }" />
                      </div>

                      <div class="pl-1 error-message"
                        *ngIf="(details.get('rate')?.errors || details.get('premiumRate')?.errors || details.errors) && (details.get('rate')?.touched || details.get('rate')?.dirty || details.get('premiumRate')?.touched || details.get('premiumRate')?.dirty)">
                        <span
                          *ngIf="details.get('rate')?.errors?.['required']">Rate
                          is required</span>
                        <span *ngIf="details.get('rate')?.errors?.['min']">Rate
                          must be at least {{
                          details.get('rate')?.errors?.['min']?.min | currency:'USD':'symbol':'1.2-2' }}</span>
                        <span *ngIf="details.get('rate')?.errors?.['max']">Rate
                          must be at most {{
                          details.get('rate')?.errors?.['max']?.max | currency:'USD':'symbol':'1.2-2' }}</span>
                        <span *ngIf="details.get('rate')?.errors?.['pattern']">Rate
                          allows up to 2 decimal places</span>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                  }
                  @case('premiumRate') {
                  <nz-form-item>
                    <nz-form-control>
                      <div class="d-flex">
                        <input nz-input formControlName="premiumRate"
                          [id]="'premium_' + i" placeholder="Premium"
                          style="width: 120px;"
                          [ngClass]="{'error': details.errors?.['premiumInvalid'] }" />
                      </div>
                      <div class="pl-1 error-message"
                        *ngIf="(details.get('rate')?.errors || details.get('premiumRate')?.errors || details.errors) && (details.get('rate')?.touched || details.get('rate')?.dirty || details.get('premiumRate')?.touched || details.get('premiumRate')?.dirty)">
                        <span
                          *ngIf="details.get('premiumRate')?.errors?.['min']">Premium
                          must be at least {{
                          details.get('premiumRate')?.errors?.['min']?.min
                          }}</span>
                        <span *ngIf="details.get('premiumRate')?.errors?.['pattern']">Premium Rate
                          allows up to 2 decimal places</span>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                  }
                  @case('actions') {
                  <div class="mobile-actions d-flex">
                    <!-- keep action icons compact for mobile -->
                    <ppl-button label *ngIf="showAddButton(i)"
                      (click)="addRow(i)" icon="fa fa-plus"
                      [customClass]="'ghost-button'"></ppl-button>
                    <ppl-button label *ngIf="showDeleteButton(i)"
                      (click)="deleteRow(i)" icon="pi pi-trash"
                      [style.margin-left]="mode === 'update'? '5px': '0px'"
                      [customClass]="'ghost-button'"></ppl-button>
                  </div>
                  }
                  }
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </form>
      <div class="custom-row">
        <ppl-button [label]="'Close'" [icon]="'fa fa-close'"
          style="margin-right:4px; font-size:0.857rem;"
          [customClass]="'ghost-button'" [iconPosition]="'right'"
          (click)="cancel()"></ppl-button>
        @if(isSectionEditable) {
        <ppl-button [label]="mode === 'add' ? 'Submit' : 'Update'" icon="fa fa-check-circle"
          [customClass]="'primary-button'" [iconPosition]="'right'"
          (click)="createRate()"></ppl-button>
        }
      </div>
    </div>
  </div>
  }
</ng-template>

<div class="filter-panel">
  <ng-template #confirmationDialog let-cancel="cancel">
    <p> The change may impact already-submitted timesheets and that the user should check whether adjustments are needed. Are you sure you want to inactivate the rate ?</p>
  </ng-template>
</div>
<div class="filter-panel">
  <ng-template #noSelectionDialog let-cancel="cancel">
    <p> Please select at least one service rate row to update.</p>
  </ng-template>
  <ng-template #backdatedEndDateDialog let-cancel="cancel">
    <p>End date can only be shortened. It cannot be earlier than today or later than the original end date.</p>
  </ng-template>
</div>
